import nl2br from "react-nl2br";
import ErrorTemplate from "../../../components/templates/ErrorTemplate/index";

interface Props {
  maintenance: string | null;
}

const MaintenanceErrorErrorPage = (props: Props) => {
  return (
    <ErrorTemplate
      title={"ただいまメンテナンス中です"}
      heading={"ただいまメンテナンス中です"}
      hideButton={true}
    >
      <p>{nl2br(props.maintenance)}</p>
    </ErrorTemplate>
  );
};

export default MaintenanceErrorErrorPage;
